// extracted by mini-css-extract-plugin
export var printerCard = "_am-1";
export var printerCardConfigured = "_am-2";
export var printerCardError = "_am-3";
export var printerCardsContainer = "_am-0";
export var printerIcon = "_am-8";
export var printerIconConfigured = "_am-5";
export var printerIconContainer = "_am-4";
export var printerIconError = "_am-6";
export var printerIconUnconfigured = "_am-7";